import { isNumber } from "./Data"

export const formatCurrency = (value) => {
  if (!value) return value
  if (!isNumber(value)) return value
  if (isNumber(value)) {
    value = value.toString()
  }
  const num = parseFloat(value.replace(/[^0-9.]/g, ''))
  return num ? num.toLocaleString() : ''
}
